(function () {
    "use strict";

    angular
        .module("Finance")
        .controller("homeController", [
            function() {
            }
        ]);
})();
